<template>
  <div
    id="preview"
    class="web-push-preview"
  >
    <div
      v-if="previewType"
      class="web-push-preview-wrapper"
      :class="`web-push-preview--${previewType.id}`"
    >
      <component
        :is="`${previewType.component}Preview`"
        :template="template"
        class="web-push-preview__body"
      ></component>

      <!-- <div class="web-push-preview__choices">
        <button
          v-for="(btn, btnIndex) in types"
          :key="btnIndex"
          :title="btn.label"
          :class="{ 'btn--active': previewType.id === btn.id }"
          @click="previewType = btn"
        >
          <img
            v-if="btn.img"
            :src="require(`@/assets/images/${btn.img}`)"
            :alt="btn.label"
          />
        </button>
      </div> -->

      <div class="web-push-preview-empty">
        Внешний вид PUSH и взаимное расположение элементов могут
        отличаться в зависимости от браузера
      </div>
    </div>
  </div>
</template>

<script>
import methods from "@/components/nodes/previewMethods.js";
import AndroidPreview from "./WebpushPreviewParts/Android.vue";
import WindowsPreview from "./WebpushPreviewParts/Windows.vue";
import Windows10Preview from "./WebpushPreviewParts/Windows10.vue";
import OldPreview from "./WebpushPreviewParts/Old.vue";

export default {
  name: "web-push-preview",

  mixins: [methods],

  components: {
    AndroidPreview,
    WindowsPreview,
    Windows10Preview,
    OldPreview
  },

  data() {
    return {
      previewType: null,
      types: [
        {
          id: "windows10_chrome",
          label: "Windows 10, Chrome, >68",
          component: "Windows10",
          img: "windows10_icon.png"
        },
        {
          id: "windows_chrome",
          label: "Windows, Chrome",
          component: "Windows",
          img: "windows_icon.png"
        },
        {
          id: "android_chrome",
          label: "Android, Chrome",
          component: "Android",
          img: "android.png"
        },
        // {
        //   id: "old",
        //   label: "",
        //   component: "Old",
        //   img: "windows10_icon.png"
        // }
      ]
    }
  },

  mounted() {
    this.previewType = this.types[0];
  },

  methods: {
    onOpenUrl(url) {
      window.open(url, "_blank");
    }
  }
}
</script>

<style lang="scss">
$preview-width: 435px;

.web-push-preview {
  display: grid;
  grid-template-columns: 1fr;
  align-items: baseline;
  justify-items: center;
  position: relative;

  &__body {
    background-color: #fff;
    margin: 0 auto 15px;
    width: $preview-width;
    border: #d7d7d7;
    box-sizing: border-box;
    box-shadow: 2px 2px 10px 1px rgba(0, 0, 0, 0.1);
    overflow: hidden;
  }

  &-empty {
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 19px;
    text-align: center;
    color: #6d6d6d;
    overflow: hidden;
  }

  &__choices {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    margin-bottom: 15px;

    button {
      background: none;
      border-bottom: 2px solid transparent;
      border-radius: 0;
      padding: 0 10px;
      margin: 0 5px;
      &:hover {
        opacity: 0.8;
      }
    }

    .btn--active {
      border-bottom: 2px solid $color_green;
    }
  }
}
</style>
